import moment from 'moment';

angular.module('am4')
.constant('langRegex', /^[a-z]{2}([-_][A-Z]{2})?$/)
.controller('langController', function($translate, $stateParams) {
    // set the moment locale for all subcontrollers to use
    moment.locale($stateParams.lang);
});



// WEBPACK FOOTER //
// ./src/app/controllers/lang.js